// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, boolean, number } from "@altostra/type-validations/lib/primitives";

export const isGetAppGroupsAppGroupIdPlacementsResult = objectOf({
  id: string,
  placement_id: string,
  name: string,
  description: string,
  created_at: number,
  marked_as_deleted: boolean,
  active_campaign_ids: arrayOf(string),
  max_banner_campaigns_per_placement: number,
  created_by_id: string,
  created_by_name: string,
});

export const isPostAppGroupsAppGroupIdPlacementsResult = objectOf({
  id: string,
  placement_id: string,
  name: string,
  description: string,
  marked_as_deleted: boolean,
  app_group_id: string,
  created_at: number,
  created_by_id: string,
  last_edited_at: number,
  last_edited_by_id: string,
});
